export default "__VITE_ASSET__DEdagtJ___"